import { Component, OnDestroy, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { WithdrawService } from '@app/core/account/withdraw.service';

@Component({
  selector: 'app-confirm-withdrawal-modal',
  templateUrl: './confirm-withdrawal-modal.template.html',
  styleUrls: ['./confirm-withdrawal-modal.template.scss'],
  animations: [],
})
export class ConfirmWithdrawalModalComponent implements OnInit, OnDestroy, AfterViewInit {
  loading = true;
  data: any;

  _dataSubscription: Subscription;
  _requestSubscription: Subscription;

  _code: string;
  _requestId: string;

  constructor(
    private service: WithdrawService,
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    protected renderer: Renderer2
  ) {}

  public ngOnInit() {}

  public ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['confirmWithdrawal'] && params['request']) {
        this._code = params['confirmWithdrawal'];
        this._requestId = params['request'];
        this._dataSubscription = this.service.getWithdrawalRequest(this._requestId, this._code).subscribe(
          data => {
            this.data = data;
            this.loading = false;
          },
          e => {
            this.modalService
              .openAlert({
                title: 'Error',
                text: 'Withdrawal request is invalid or expired.',
              })
              .result.then(() => {
                this.router.navigate(['/', { outlets: { modal: null } }]);
              })
              .catch(() => {
                this.router.navigate(['/', { outlets: { modal: null } }]);
              });
          }
        );
      }
    });
  }

  public submit(state: string): void {
    if (this._requestSubscription) {
      this._requestSubscription.unsubscribe();
    }
    this._dataSubscription = this.service.confirmWithdrawalRequest(this._requestId, this._code, state).subscribe(
      data => {
        this.modalService
          .openAlert({
            title: 'Success',
            text:
              state === 'confirm'
                ? 'Your withdrawal request was confirmed and will be completed shortly.'
                : 'Withdrawal request was canceled. Reserved funds will be back in your balance shortly.',
          })
          .result.then(() => {
            this.router.navigate(['/', { outlets: { modal: null } }]);
          })
          .catch(() => {
            this.router.navigate(['/', { outlets: { modal: null } }]);
          });
      },
      e => {
        this.modalService.openAlert({
          title: 'Error',
          text: e.json().message,
        });
      }
    );
  }

  public ngOnDestroy() {
    if (this._dataSubscription) {
      this._dataSubscription.unsubscribe();
    }
    if (this._requestSubscription) {
      this._requestSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/confirm-withdrawal/confirm-withdrawal-modal.component.ts